import { render, staticRenderFns } from "./public-foot-audio.vue?vue&type=template&id=13454413&scoped=true&"
import script from "./public-foot-audio.vue?vue&type=script&lang=js&"
export * from "./public-foot-audio.vue?vue&type=script&lang=js&"
import style0 from "./public-foot-audio.vue?vue&type=style&index=0&id=13454413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13454413",
  null
  
)

export default component.exports